import { render, staticRenderFns } from "./OtherDisplays.vue?vue&type=template&id=147cd237&"
import script from "./OtherDisplays.vue?vue&type=script&lang=js&"
export * from "./OtherDisplays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports